/* eslint-disable @typescript-eslint/camelcase */
import * as pubstackApi from '~/api/story'
import { hasPermission } from '~/modules/services/permission'
import { EllipsisReduxStore } from '~/types/redux'
import { setLastActiveTime } from './activity-utils'

const isReadOnly = (): boolean => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    hasPermission(window.userRolesAuth.story.viewStory) &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    !hasPermission(window.userRolesAuth.story.editStory)
  )
}

export const setIsValidTab = (documentId) => {
  window.sessionStorage.setItem(`${documentId}_valid_tab`, 'true')
}

export const getIsValidTab = (documentId) => {
  return !!window.sessionStorage.getItem(`${documentId}_valid_tab`)
}

export const acquireDocumentLock = async (
  documentId
): Promise<EllipsisReduxStore['appState']['lockDetails']> => {
  const createLockResult = await pubstackApi.createLock(documentId, [
    'DOCUMENT',
  ])
  const { user_id } =
    createLockResult.locks.find((lock) => lock.attribute === 'DOCUMENT') || {}

  if (!user_id) throw new Error('Document lock acquisition failed.')

  setLastActiveTime(documentId)

  return {
    isMyLock: true,
    readonly: isReadOnly(),
    lockedBy: user_id,
  }
}

export const getDocumentLockDetails = async (
  documentId
): Promise<EllipsisReduxStore['appState']['lockDetails']> => {
  const getLocksResult = await pubstackApi.getLocks({
    documentIds: [documentId],
    attribute: 'DOCUMENT',
    dropTracker: true,
  })

  if (!getLocksResult.locks.length) {
    return {
      isMyLock: false,
      readonly: isReadOnly(),
      lockedBy: undefined,
    }
  }

  const myLockRecord = getLocksResult.locks.find(
    (lock) => lock.user_id === window.localStorage.getItem('arc.username')
  )
  if (myLockRecord) {
    return {
      isMyLock: true,
      readonly: isReadOnly(),
      lockedBy: myLockRecord.user_id,
    }
  }

  return {
    isMyLock: false,
    readonly: isReadOnly(),
    lockedBy: getLocksResult.locks[0].user_id,
    lockedByDisplayName: getLocksResult.locks[0].display_name,
  }
}
